module.exports = __webpack_public_path__ + "static/media/display-area.57c0beb5.png";